"use client";

import { useId, type CSSProperties } from "react";

type CcConversionRangeProps = {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  /** Visible value next to the label, already formatted with its unit. */
  display: string;
  onChange: (value: number) => void;
};

/** Labelled slider used by the popup calculators. */
export function CcConversionRange({ label, value, min, max, step, display, onChange }: CcConversionRangeProps) {
  const id = useId();
  const filled = ((value - min) / (max - min)) * 100;
  return (
    <div className="cc-convert__range">
      <div className="cc-convert__range-head">
        <label htmlFor={id}>{label}</label>
        <output htmlFor={id}>{display}</output>
      </div>
      <input
        id={id}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        style={{ "--cc-convert-fill": `${filled}%` } as CSSProperties}
        aria-valuetext={display}
      />
    </div>
  );
}
